import { atom, useRecoilValue, useSetRecoilState } from "recoil";

export const userLocationState = atom({
  key: "userLocationState",
  default: null,
});

export const useUserLocation = () => {
  const location = useRecoilValue(userLocationState);
  const setLocation = useSetRecoilState(userLocationState);
  return { location, setLocation };
};
